export const PURCHASE_STATUS_LIST_MUTATION = "PURCHASE_STATUS_LIST_MUTATION";
export const PURCHASE_KEYWORD_LIST_MUTATION = "PURCHASE_KEYWORD_LIST_MUTATION";
